import { makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import Search from "../../images/icons/search.svg";

const styles = makeStyles({
    messageSearch: {
        justifyContent: 'center', 
        flexDirection: 'column', 
        alignItems: 'center', 
        marginTop: '10%',
        display: 'flex', 
      },
})

const NotFile = () => {
    const classes = styles()
  return (
    <React.Fragment>
        <div className={classes.messageSearch}>
        <img src={Search} alt="" />
        <Typography style={{ paddingTop: "20px", paddingLeft: "20px" }}>
            No se encontraron registros con los criterios de búsqueda
        </Typography>
        </div>
    </React.Fragment>
  )
}

export default NotFile;